import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';


// TODO Dependency
import {TicketObjectDto} from "../../../../../model/dto/entity/ticket-object.dto";
import {TicketTypeObjectRoleDto} from "../../../../../model/dto/entity/ticket-type-object-role.dto";
import {firstValueFrom} from "rxjs";
import {MenuItem} from "primeng/api";
import {ContextMenu} from "primeng/contextmenu";
import {ObjectIdentifier} from "../../../../../../../core/shared/basic/object-identifier";
import {DtoImportObjectContext} from "../../../../../../../core/shared/dto/dto.import.object.context";
import {ObjectTypeService} from "../../../../../../../core/cc/service/api/object-type.service";
import {MvsCoreService} from "../../../../../../../core/shared/service/mvs-core.service";
import {MvsObjectNavigationService} from "../../../../../../../core/shared/navigation/mvs-object-navigation.service";
import {MvsUiObjectService} from "../../../../../../../core/shared/object/service/mvs-ui-object.service";
import {DtoImportObjectContextEntry} from "../../../../../../../core/shared/dto/dto.import.object.context.entry";
import {ObjectRequestList} from "../../../../../../../core/shared/dto/object/request/object-request-list";
import {FilterCriteria} from "../../../../../../../core/shared/filter/api/filter.criteria";
import {MvsObjectNavigationEntry} from "../../../../../../../core/shared/navigation/mvs-object-navigation-entry";
import {
    MvsObjectNavigationActionEnum
} from "../../../../../../../core/shared/navigation/mvs-object-navigation-action-enum";
import {ObjectRequestComplex} from "../../../../../../../core/shared/dto/object/request/object-request-complex";
import {
    ObjectRequestComplexNode
} from "../../../../../../../core/shared/dto/object/request/object-request-complex-node";
import {WidgetHelperButton} from "../../../../../../../core/shared/basic/widget-helper-button";
import {MvsCrudService} from "../../../../../../../core/shared/service/crud/mvs-crud.service";

@Component({
    selector: 'tm-ticket-landing-components',
    templateUrl: './tm-ticket-landing-components.component.html',
    standalone: false
})
export class TmTicketLandingComponentsComponent implements OnInit, OnChanges, OnDestroy {

    ticketTypeObjectRoleService: MvsCrudService;
    ticketObjectService: MvsCrudService;
    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized

    @Input() ticketObjects: TicketObjectDto[];
    @Input() importObjectContext: DtoImportObjectContext;
    @Input() objectIdentifier: ObjectIdentifier;
    @Input() fullPage: boolean = false;
    @Input() ticketTypeId: number;

    @Output() onObjectSelect = new EventEmitter<ObjectIdentifier>();
    @Output() onObjectChanged: EventEmitter<any> = new EventEmitter();
    @Output() changeMode: EventEmitter<string> = new EventEmitter();
    @Output() onInitiateCustomerInteraction = new EventEmitter<ObjectIdentifier>;

    ticketObjectContext: DtoImportObjectContext;
    ticketObjectToolbarButtons: MenuItem[] = [
        {
            label: 'Open in background',
            icon: 'fa-regular fa-send-backward',
            display: true,
            action: 'background',
            tooltip: 'Open in background'
        },
        {
            label: 'Open in new window',
            icon: 'fa-regular fa-window-restore',
            display: true,
            action: 'newWindow',
            tooltip: 'Open in new window'
        },
        {
            label: 'Open in sidebar',
            icon: 'fa-regular fa-sidebar',
            display: false,
            action: 'sidebar',
            tooltip: 'Open in sidebar'
        },

        {
            label: 'Delete',
            icon: 'fa-regular fa-trash',
            display: true,
            action: 'delete',
            tooltip: 'Delete Object'
        }
    ];
    ticketTypeAvailableRoles: TicketTypeObjectRoleDto[];

    contextMenuItems: any[];
    selectedContextMenuEntry: TicketObjectDto;
    @ViewChild("cm1") contextMenu!: ContextMenu;

    objectTypeAliasMap: Map<number, string> = new Map();
    documentMimeTypeMap: Map<number, string> = new Map();
    documentDetailsMap: Map<number, any> = new Map();

    constructor(
        protected objectTypeService: ObjectTypeService, protected coreService: MvsCoreService,
        protected navigationService: MvsObjectNavigationService,
        protected objectService: MvsUiObjectService) {
        this.ticketTypeObjectRoleService = this.coreService.getCrudService("tm.TicketTypeObjectRole");

        this.ticketObjectService = this.coreService.getCrudService("tm.TicketObject");

    }

    ngOnInit(): void {
        this.initComponent();
        this.refreshComponent();
    }

    /**
     * Initialize Component.
     */
    initComponent() {

        this.ticketObjectContext = new DtoImportObjectContext([new DtoImportObjectContextEntry('tm.Ticket', this.objectIdentifier.objectId)]);
        this.getAvailableRoles();

    }

    async prepareContextMenu() {
        const generalToolbarButtons = structuredClone(this.ticketObjectToolbarButtons);
        const objectAlias: string = await this.getObjectAlias(this.selectedContextMenuEntry.objectTypeDtoId);
        this.contextMenuItems = [];

        for (let item of generalToolbarButtons) {
            if ((item.action === 'sidebar' && objectAlias == 'cr.Customer') ||
                (item.action === 'background' && objectAlias != 'cr.Customer')) {
                continue;
            }
            const contextMenuItem = {
                label: item.label,
                icon: item.icon,
                display: item.display,
                action: item.action,
                tooltip: item.tooltip,
                command: () => this.handleButtonClick(item)
            }

            this.contextMenuItems.push(contextMenuItem);
        }

        // check for available roles, if exist then show in context menu
        if (this.ticketTypeAvailableRoles && this.ticketTypeAvailableRoles.length) {
            const contextMenuItemAdd = {
                label: 'Change Role',
                icon: 'pi pi-plus',
                display: true,
                action: 'addRole',
                tooltip: 'Add Object Role',
                items: []
            }

            for (let item of this.ticketTypeAvailableRoles) {

                if (this.selectedContextMenuEntry.ticketTypeObjectRoleDtoId == item.id) {
                    continue;
                }

                const child = {
                    label: item.name,
                    icon: item.image,
                    command: () => this.addObjectRole(item)
                }
                contextMenuItemAdd.items.push(child);
            }

            if (contextMenuItemAdd.items.length > 0) {
                this.contextMenuItems.push(contextMenuItemAdd);
            }

        }


        // if it has a role assigned then show remove button
        if (this.selectedContextMenuEntry.ticketTypeObjectRoleDtoId) {
            const contextMenuItem = {
                label: 'Remove role',
                icon: 'fa-regular fa-trash',
                display: true,
                action: 'removeRole',
                tooltip: 'Remove object role',
                command: () => this.removeObjectRole()
            }
            this.contextMenuItems.push(contextMenuItem);
        }

    }

    addObjectRole(item: TicketTypeObjectRoleDto) {
        if (this.busy) {
            return;
        }

        this.busy = true;
        const dto = new TicketObjectDto();
        dto.id = this.selectedContextMenuEntry.id;
        dto.ticketTypeObjectRoleDtoId = item.id;
        this.ticketObjectService.update(dto).subscribe(res => {
            this.busy = false;
        }, error => {
            this.busy = false;
        })
    }

    removeObjectRole() {
        if (this.busy) {
            return;
        }

        this.busy = true;
        const dto = new TicketObjectDto();
        dto.id = this.selectedContextMenuEntry.id;
        dto.ticketTypeObjectRoleDtoId = null;
        this.ticketObjectService.update(dto).subscribe(res => {
            this.busy = false;
        }, error => {
            this.busy = false;
        })
    }

    getAvailableRoles() {
        if (this.ticketTypeAvailableRoles && this.ticketTypeAvailableRoles.length) {
            return; // roles are retrieved once, no need to retrieve again
        }

        const objectRequest = new ObjectRequestList(
            false,
            [FilterCriteria.create('ticketType', FilterCriteria.cOperatorEqual, this.ticketTypeId)],
            []
        );

        this.ticketTypeObjectRoleService.list(objectRequest).subscribe(res => {
            this.ticketTypeAvailableRoles = res.entries;
        })
    }

    async handleButtonClick(event: MenuItem) {
        const objectAlias: string = await this.getObjectAlias(this.selectedContextMenuEntry.objectTypeDtoId);

        if (!objectAlias) {
            return;
        }

        const identifier = new ObjectIdentifier(objectAlias, this.selectedContextMenuEntry.objectId);

        const navigationEntry = MvsObjectNavigationEntry.createNavigationEntry(identifier.objectType, identifier.objectId, null, identifier.objectType, null, null, MvsObjectNavigationActionEnum.any);
        if (event.action == 'background') {
            this.navigationService.addOverlay(navigationEntry)
        } else if (event.action == 'newWindow') {
            this.navigationService.handleObjectNavigation(identifier, null, {openNewTab: true});
        } else if (event.action == 'delete') {
            this.deleteTicketObject();
        } else if (event.action == 'sidebar' && objectAlias == 'cr.CustomerInteraction') {
            const mvsObjectNavigationEntry = MvsObjectNavigationEntry.createNavigationEntry(identifier.objectType, identifier.objectId, null, identifier.objectType, null, null, MvsObjectNavigationActionEnum.any);
            this.navigationService.navigateTo(mvsObjectNavigationEntry, 'left');
            console.log("cusid", identifier.objectId);
        }
    }

    deleteTicketObject() {
        if (this.busy || !this.selectedContextMenuEntry.objectTypeDtoId) {
            return;
        }
        this.busy = true;
        this.ticketObjectService.delete(this.selectedContextMenuEntry.id).subscribe(res => {
            this.busy = false;
        }, error => {
            console.log(error);
            this.busy = false;
        });
    }

    async getObjectAlias(objectTypeId: number): Promise<string> {
        if (!objectTypeId) {
            return null;
        }

        const res = await this.objectTypeService.getViaObjectId(this.selectedContextMenuEntry.objectTypeDtoId);
        return res.alias;
    }


    /**
     * Refresh Component.
     */
    refreshComponent() {
        // this.initialized = false;
        this.prepareTicketRoles();
        // this.getTicketObjectIdentifier();
    }

    async prepareTicketRoles() {

        if (!this.ticketObjects || !this.ticketObjects.length) {
            this.initialized = true;
            return;
        }

        await this.resolveObjectTypeAliases();

        for (const item of this.ticketObjects) {
            const roleDto = await this.getObjectTicketRoles(item.objectTypeDtoId, item.objectId);
            item.ticketTypeObjectRoleDto = roleDto;
        }

        await this.resolveDocumentMimeTypes();

        this.initialized = true;
    }

    async resolveObjectTypeAliases() {
        const uniqueTypeIds = [...new Set(this.ticketObjects.map(o => o.objectTypeDtoId).filter(id => id != null))];
        for (const typeId of uniqueTypeIds) {
            if (!this.objectTypeAliasMap.has(typeId)) {
                const typeDto = await this.objectTypeService.getViaObjectId(typeId);
                this.objectTypeAliasMap.set(typeId, typeDto.alias);
            }
        }
    }

    async resolveDocumentMimeTypes() {
        const documentObjects = this.ticketObjects.filter(o => this.isDocumentObject(o.objectTypeDtoId));
        if (!documentObjects.length) {
            return;
        }

        const documentService = <MvsCrudService>this.coreService.getCrudService('dm.DmDocument');
        for (const obj of documentObjects) {
            if (!this.documentMimeTypeMap.has(obj.objectId)) {
                try {
                    const doc = await firstValueFrom(documentService.get(obj.objectId));
                    this.documentMimeTypeMap.set(obj.objectId, doc['mimeType'] || 'application/pdf');
                    this.documentDetailsMap.set(obj.objectId, doc);
                } catch {
                    this.documentMimeTypeMap.set(obj.objectId, 'application/pdf');
                }
            }
        }
    }

    isDocumentObject(objectTypeDtoId: number): boolean {
        return this.objectTypeAliasMap.get(objectTypeDtoId) === 'dm.DmDocument';
    }

    // TM-1000001468: Separate ticket objects by type for different layouts
    get nonDocumentObjects(): TicketObjectDto[] {
        if (!this.ticketObjects) return [];
        return this.ticketObjects.filter(obj => !this.isDocumentObject(obj.objectTypeDtoId));
    }

    get documentObjects(): TicketObjectDto[] {
        if (!this.ticketObjects) return [];
        return this.ticketObjects.filter(obj => this.isDocumentObject(obj.objectTypeDtoId));
    }

    getDocumentMimeType(objectId: number): string {
        return this.documentMimeTypeMap.get(objectId) || 'application/pdf';
    }

    getDocumentDetails(objectId: number): any {
        return this.documentDetailsMap.get(objectId);
    }

    openDocumentInSidebar(object: TicketObjectDto) {
        const entry = MvsObjectNavigationEntry.createNavigationEntry(
            'dm.DmDocument',
            object.objectId,
            'object',
            'Dokument',
            null,
            null,
            MvsObjectNavigationActionEnum.any,
            'side'
        );
        this.navigationService.navigateTo(entry, 'left');
    }

    async getObjectTicketRoles(objectTypeId: number, objectId: number): Promise<TicketTypeObjectRoleDto | undefined> {
        const filterCriteria = [];
        filterCriteria.push(FilterCriteria.create('objectType', FilterCriteria.cOperatorEqual, objectTypeId));
        filterCriteria.push(FilterCriteria.create('objectId', FilterCriteria.cOperatorEqual, objectId));
        filterCriteria.push(FilterCriteria.create('ticket', FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId));

        const objectRequest = new ObjectRequestList(true, filterCriteria, []);
        objectRequest.objectRequestComplex = ObjectRequestComplex.build(
            true,
            false,
            ObjectRequestComplexNode.createSimpleAttributeNode('ticketTypeObjectRole')
        );

        const response = await firstValueFrom(this.ticketObjectService.list(objectRequest));
        return response.entries[0]?.ticketTypeObjectRoleDto;
    }

    handleTicketTypeToolbarButton(event: WidgetHelperButton, objectIdentifier: ObjectIdentifier) {
        if (event.action == 'background') {
            this.navigationService.changeMainObject(objectIdentifier);
        } else if (event.action == 'sidebar') {
            const mvsObjectNavigationEntry = MvsObjectNavigationEntry.createNavigationEntry(objectIdentifier.objectType, objectIdentifier.objectId, null, objectIdentifier.objectType, null, null, MvsObjectNavigationActionEnum.any);
            this.navigationService.navigateTo(mvsObjectNavigationEntry, 'left');
        }
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes['ticketObjects']) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }

    handleContextMenu(object: TicketObjectDto, event: MouseEvent) {
        this.selectedContextMenuEntry = object;
        this.prepareContextMenu();
        this.contextMenu.toggle(event);
        event.preventDefault();
    }

    handleObjectSelect(objectIdentifier: ObjectIdentifier) {

        if (objectIdentifier.objectType == 'cr.CustomerInteraction') {
            this.onObjectSelect.emit(objectIdentifier);
        }

    }

}
